import * as Yup from 'yup';
import { countryOptions } from '../configs/profile';

export const organizationAddressValues = (account) => Object.fromEntries(
    ['street', 'zip', 'city', 'province', 'country'].map((key) => [key, account?.address?.[key] || ''])
);
export const organizationAddressSchema = (initial) => Yup.object({
    street: Yup.string().trim().max(200, 'Utilize até 200 caracteres.'),
    zip: Yup.string().trim().max(15, 'Utilize até 15 caracteres.'),
    city: Yup.string().trim().max(30, 'Utilize até 30 caracteres.'),
    province: Yup.string().trim().max(30, 'Utilize até 30 caracteres.'),
    country: Yup.string().oneOf(['', initial.country, ...countryOptions.map((option) => option.value)])
        .test('clear-country', 'Selecione um país. O país existente não pode ser removido.', (value) => !initial.country || Boolean(value))
});
export const buildOrganizationAddressPatch = (values, initial) => {
    const patch = {};
    for (const key of ['street', 'zip', 'city', 'province', 'country']) {
        const value = values[key].trim();
        if (key === 'country' && !value && initial.country) throw new Error('COUNTRY_CANNOT_BE_CLEARED');
        if (value !== initial[key]) patch[key] = value;
    }
    return patch;
};

// Update account metadata across the user's roles without changing personal role contacts.
export const mergeOrganizationAccount = (user, accountUuid, patch) => {
    if (!user?.roles) return user;
    return {
        ...user, roles: user.roles.map((role) => role.account?.uuid === accountUuid ? {
            ...role, account: {
                ...role.account,
                ...(patch.picture ? { picture: patch.picture } : {}),
                ...(patch.address ? { address: { ...role.account.address, ...patch.address } } : {})
            }
        } : role)
    };
};
